document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".product-grid-list .product-list-card").forEach(function (card) {
    productDataUpdate(card, false);
  });
  document.querySelectorAll(".related-product-card").forEach(function (card) {
    productDataUpdate(card, false);
  });
  document.querySelectorAll(".pdp-main-wrapper").forEach(function (card) {
    productDataUpdate(card, true);
  });
  document.querySelectorAll(".custom-pdp-two-col-section:not(.new-pdp-layout-section)").forEach(function (card) {
    productDataUpdate(card, true);
  });
  document.querySelectorAll(".product-card-wrapper").forEach(function (card) {
  productDataUpdate(card, false);
  });  
});

function productDataUpdate(card, isPDP){
  let buttons = card.querySelectorAll(".product-selector-color");
  if (buttons.length === 0) {
    buttons = card.querySelectorAll(".product-selector-options");
  }
  const imageEl = card.querySelector("[data-product-image]");
  const priceEl = card.querySelector("[data-actual-price]");
  const comparePriceEl = card.querySelector("[data-compare-price]");
  const pdpImageEls = card.querySelectorAll(".pdp-image-video-wrap");
  const buyButtonEl = card.querySelector("[data-buyButton]");
  const cardAnchorEls = card.querySelectorAll("a[data-product-url]");
  const productInfoTextEl = card.querySelector(".product-details .product-info-text[data-product-info]");
  const priceWrap = card.querySelector(".product-price[data-variant-id]");

  // COMING-SOON-FIX-2026-10-05: the card wrapper that carries the `coming-soon`
  const cardWrapperEl = card.classList.contains("product-card-wrapper")
    ? card
    : card.querySelector(".product-card-wrapper");

  const addToCartText = card.getAttribute("data-addToCartText");
  const soldOutText = card.getAttribute("data-soldOutText");

  const priceOuterEl = card.querySelector("[data-price-outer]");
  
  buttons.forEach(function (btn) {
    btn.addEventListener("click", function () {
      // Remove active class
      buttons.forEach(b => b.classList.remove("active"));
      btn.classList.add("active");
  
      const productId = btn.getAttribute("data-product-id");
      const variantId = btn.getAttribute("data-variant-id");
      const sku = btn.getAttribute("data-variant-sku");
      const img = btn.getAttribute("data-image");
      const price = btn.getAttribute("data-price");
      const compareAtPrice = btn.getAttribute("data-compare-at-price");
      const availability = btn.getAttribute("data-availability");
      const variantURL = btn.getAttribute("data-url");
      const product_color = btn.getAttribute("data-color");
      const isComingSoon = btn.getAttribute("data-coming-soon")=='true';
      const isPreorder = btn.getAttribute("data-is-preorder") === "true";
      
      const rawPrice = btn.getAttribute("data-raw-price");
      const rawCompareAtPrice = btn.getAttribute("data-raw-compare-at-price");
      const formatRawPrice = Number(rawPrice)
      const formatRawCompareAtPrice = Number(rawCompareAtPrice)
      const savePrice = formatRawCompareAtPrice - formatRawPrice;

      if (cardWrapperEl) {
        cardWrapperEl.classList.toggle("coming-soon", isComingSoon);
        // COMING-SOON-FIX-2026-10-05
        cardWrapperEl.setAttribute("data-coming-soon", isComingSoon);
      }

      // Update image
      if(isPDP){
        if(pdpImageEls){
          const btnDataLink = btn.getAttribute("data-link");
          pdpImageEls.forEach(el => {
            if (el.getAttribute("data-id") === btnDataLink) {
              el.classList.add("active");
            } else {
              el.classList.remove("active");
            }
          });
        }

        const colorText = document.querySelector(".color-text");
    
        if (colorText) {
            colorText.textContent = product_color;
        }
        if (product_color){
           const variantGalleryImages = document.querySelectorAll('.variant-color-image-'+product_color);
           if (variantGalleryImages.length > 0) {
              $('.variant-gallery-images').hide();
               variantGalleryImages.forEach(el => {
                el.style.display = 'block';
              });
           }
        }
                
        
        // Update for PDP Top sticky bar start
        const pdpTopBarEl = document.querySelector(".pdp-top-sticky-bar");

        const priceOuterStickyEl = pdpTopBarEl?.querySelector("[data-price-outer-sticky]");
        
        if (pdpTopBarEl) {
          const pdpTopBuyButtonEl = pdpTopBarEl.querySelector("[data-buyButton]");
          const pdpTopBuyButtonTextEls = pdpTopBuyButtonEl?.querySelectorAll("[data-buyButtonText]");
          const actualPriceEl = pdpTopBarEl.querySelector("[data-actual-price]");
          const comparePriceEle = pdpTopBarEl.querySelector("[data-compare-price]");
        
          if (pdpTopBuyButtonEl && pdpTopBuyButtonTextEls && !isComingSoon) {
            if (availability === 'true' || availability === true) {
              pdpTopBuyButtonTextEls.forEach(el => {
                const wrapper = el.closest('.add-to-cart-text');

                const translatedAddToCart = wrapper?.dataset.translatedAddToCart 
                  || wrapper?.dataset.addtocarttext;

                el.textContent = isPreorder ? "Pre-order" : translatedAddToCart;
              });

              pdpTopBuyButtonEl.removeAttribute("disabled");

            } else {

              pdpTopBuyButtonTextEls.forEach(el => {

                const wrapper = el.closest('.add-to-cart-text');

                const translatedSoldOut = wrapper?.dataset.translatedSoldOut 
                  || wrapper?.dataset.soldouttext;

                el.textContent = translatedSoldOut;

              });

              pdpTopBuyButtonEl.setAttribute("disabled", "");

            }
          }else if (pdpTopBuyButtonEl && pdpTopBuyButtonTextEls && isComingSoon) {
            // COMING-SOON-FIX-2026-10-05: 
            pdpTopBuyButtonTextEls.forEach(el => {
              el.textContent = "Coming Soon";
            });
            pdpTopBuyButtonEl.setAttribute("disabled", "");

          } 
        
          if (actualPriceEl) {
            actualPriceEl.textContent = price;
          }
        
          if (comparePriceEle) {
            if (compareAtPrice && savePrice > 0) {
              comparePriceEle.style.display = 'inline-block';
              comparePriceEle.textContent = compareAtPrice;
            } else {
              comparePriceEle.style.display = 'none';
            }
          }
        }
        //end
        
        document.querySelectorAll('.form-variant-id-' + productId).forEach(el => {
          el.value = variantId;
        });

        const newUrl = new URL(window.location.href);
        newUrl.searchParams.set('variant', variantId);

        // Update URL without page reload
        window.history.replaceState({}, '', newUrl);

        // Update the review summary and reviews when the variant changes
        setTimeout(() => {
          const elements = [
            document.getElementById("bv-rating-summary"),
            document.getElementById("bv-reviews")
          ];

          let updated = false;

          elements.forEach(el => {
            if (el && el.getAttribute("data-bv-product-id") !== sku) {
              el.setAttribute("data-bv-product-id", sku);
              updated = true;
            }
          });
        }, 100);
        
      }else{
        //document.querySelector('.form-variant-id-'+productId).value = variantId;
        const input = document.querySelector('.form-variant-id-' + productId);
        if (input) {
          input.value = variantId;
        } else {
          console.warn('No element found with class: .form-variant-id-' + productId);
        }
        
        if (img && imageEl) {
          imageEl.src = img;
        }

        //Update variant url 
        cardAnchorEls.forEach(el => {
          el.href = variantURL;
        });

        if(priceWrap){
          priceWrap.setAttribute('data-variant-id', variantId)
        }

        // Update the inline rating when the variant changes
        setTimeout(() => {
          const productId = btn.getAttribute("data-product-id");
          const bvDiv = document.getElementById(`bv-inline-rating-${productId}`);

          if (bvDiv && sku) {
              bvDiv.setAttribute("data-bv-product-id", sku);

              if (window.bvCallback) {
                  window.bvCallback();
              }
          }
        }, 100);
        
      }

      // Update addtocart button text
      if(buyButtonEl && !isComingSoon){
          const buttonTextEls = buyButtonEl.querySelectorAll("[data-buyButtonText]");
          
          if (availability === 'true' || availability === true) {
            buttonTextEls.forEach(el => {
              const wrapper = el.closest('.add-to-cart-text');

              const translatedAddToCart = wrapper?.dataset.translatedAddToCart 
                || wrapper?.dataset.addtocarttext;

              el.textContent = isPreorder ? "Pre-order" : translatedAddToCart;
            });

            buyButtonEl.removeAttribute("disabled");
            if(productInfoTextEl) {
              productInfoTextEl.style.display = 'none';
            }

          } else {

            buttonTextEls.forEach(el => {

              const wrapper = el.closest('.add-to-cart-text');

              const translatedSoldOut = wrapper?.dataset.translatedSoldOut 
                || wrapper?.dataset.soldouttext;

              el.textContent = translatedSoldOut;

            });

            buyButtonEl.setAttribute("disabled", "");

            if (productInfoTextEl) {
              productInfoTextEl.style.display = 'block';
            }
          }
      }else if (buyButtonEl && isComingSoon) {
        // COMING-SOON-FIX-2026-10-05: same gap as the sticky-bar block above -
        // switching INTO a coming-soon variant previously left the PDP-fold
        // button in its last state instead of forcing "Coming soon"/disabled.
        const buttonTextEls = buyButtonEl.querySelectorAll("[data-buyButtonText]");
        buttonTextEls.forEach(el => {
          el.textContent = "Coming Soon";
        });
        buyButtonEl.setAttribute("disabled", "");
        if(productInfoTextEl){
          productInfoTextEl.style.display = 'block';
        }
      }
  
      // COMING-SOON-FIX-2026-10-05: show/hide the whole price block
      if (priceOuterEl) {
        priceOuterEl.style.display = isComingSoon ? "none" : "";
      }

      if (priceOuterStickyEl) {
        priceOuterStickyEl.style.display = isComingSoon ? "none" : "";
      }

      // Update actual price
      if (priceEl) {
        priceEl.textContent = price;
      }
  
      // Update compare at price (or hide if not applicable)
      if (comparePriceEl) {
        if (compareAtPrice && savePrice > 0) {
          comparePriceEl.style.display = 'inline-block';
          comparePriceEl.textContent = compareAtPrice;
        } else {
          comparePriceEl.style.display = 'none';
        }
      }

      if (pricelist != undefined) {
        display_price(variantId, isPDP);
      }
      if (window.Weglot) {
        setTimeout(() => {
          document.dispatchEvent(new Event("wg:update"));
        }, 200);
      }

    });
  });
}  

//ACF custom pricing JS Start


function applyACFPricing() {
  var pricelist = getCookie("pricelist");
(() => {
  let external_price;
  let external_token;

  /** --------------------------
  * Build custom line item properties
  * -------------------------- */
  const buildCustomProperties = (external_price, external_token, pricelist) => {
    const properties = {};
    if (external_price) properties._external_price = String(external_price);
    if (external_token) properties._external_token = String(external_token);
    if (pricelist && external_price) properties._external_pricelist = pricelist;
    return properties;
  };

  /** --------------------------
  * Update cart count in header
  * -------------------------- */
  const updateCartCount = async (onReload) => {
    try {
      const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      const cart = await res.json();

      const countElem = document.querySelector('.header-actions__cart-icon .cart-bubble__text-count');
      if (countElem){
        document.querySelector('.header-actions__cart-icon').classList.add('header-actions__cart-icon--has-cart');
        document.querySelector('.header-actions__cart-icon .cart-bubble').classList.remove('visually-hidden');
        countElem.textContent = cart.item_count;
        
      }else{
        document.querySelector('.header-actions__cart-icon').classList.add('header-actions__cart-icon--has-cart');
        document.querySelector('.header-actions__cart-icon .cart-bubble').classList.remove('visually-hidden');
        document.querySelector('.header-actions__cart-icon .cart-bubble__text').innerHTML = '<span class="visually-hidden">Total items in cart:' +cart.item_count+'</span><span class="cart-bubble__text-count" aria-hidden="true">'+cart.item_count+'</span>';
      } 
      if(!onReload){
        document.querySelector('.header-actions__cart-icon .cart-bubble').classList.toggle('cart-bubble--animating');
        setTimeout(function(){
          document.querySelector('.header-actions__cart-icon .cart-bubble').classList.remove('cart-bubble--animating');
        }, 300)
      }

    } catch (err) {
      console.error('❌ Error updating cart count:', err);
    }
  };
})();
  if (pricelist != undefined) {
    var c_variant_id;
    if(document.querySelector('.pdp-main-wrapper')){
      c_variant_id = parseFloat(document.querySelector('.pdp-main-wrapper product-form-component form.shopify-product-form input[name=id]').value);
    }else if(document.querySelector('.custom-pdp-two-col-section')){
      c_variant_id = parseFloat(document.querySelector('.custom-pdp-two-col-section product-form-component form.shopify-product-form input[name=id]').value);
    }
    
    for (var prop in benefits) {
      var closed_shop = benefits[prop][pricelist];

      if (closed_shop != undefined) {
        var money_formatted = formatMoney(closed_shop.closed_shop_price, theme.moneyFormat);
        var compare_at_price_formatted = formatMoney(closed_shop.compare_price, theme.moneyFormat);
        
        document.querySelectorAll('.product-price[data-variant-id="'+prop+'"] span[data-compare-price]').forEach(el => {
          el.innerText = compare_at_price_formatted;
        });
        document.querySelectorAll('.product-price[data-variant-id="'+prop+'"] span[data-actual-price]').forEach(el => {
          el.innerText = money_formatted;
        });
        document.querySelectorAll('.product-price[data-variant-id="'+prop+'"] span[data-compare-price]').forEach(el => {
          el.style.removeProperty('display');
        });
        document.querySelectorAll('.product-price[data-variant-id="'+prop+'"]').forEach(el => {
          const next = el.nextElementSibling;
          if (!next || !next.classList.contains('promotional-price')) {
            el.insertAdjacentHTML('afterend', '<p class="promotional-price">Promotional price</p>');
          }
        });

        if(prop == c_variant_id){
          document.querySelectorAll(".closed_shop_price").forEach(el => {
            el.value = closed_shop.closed_shop_price;
            el.disabled = false;
          });
          document.querySelectorAll(".closed_shop_token").forEach(el => {
            el.value = closed_shop.closed_shop_token;
            el.disabled = false;
          });

          document.querySelectorAll(".closed_shop_pricelist").forEach(el => {
            el.value = pricelist;
            el.disabled = false;
          });
          
        }

      }
    }
  }
}
document.addEventListener('DOMContentLoaded', function() {
    applyACFPricing();
});

var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i;
  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');
    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
    }
  }
};
  

var display_price = function(current_variant_id, isPDP) {
  debugger;
  var variant_id = getUrlParameter("variant");
  if (variant_id == undefined) {
    variant_id = current_variant_id;
  }
  var variant = benefits[variant_id];
  if (variant != null && variant != undefined) {
    var pricelist = getCookie("pricelist");
    var closed_shop = variant[pricelist];

    document.querySelectorAll(".closed_shop_pricelist").forEach(el => {
      el.value = pricelist;
      el.disabled = false;
    });

    if (closed_shop != null && closed_shop != undefined) {
      
      var money_formatted = formatMoney(closed_shop.closed_shop_price, theme.moneyFormat);
      var compare_at_price_formatted = formatMoney(closed_shop.compare_price, theme.moneyFormat);
      if(isPDP){
        
          document.querySelectorAll('.pdp-main-wrapper .product-price[data-variant-id] span[data-compare-price], .pdp-top-sticky-bar .product-price[data-variant-id] span[data-compare-price], .custom-pdp-two-col-section .product-price[data-variant-id] span[data-compare-price]').forEach(el => {
            el.innerText = compare_at_price_formatted;
          });
          document.querySelectorAll('.pdp-main-wrapper .product-price[data-variant-id] span[data-actual-price], .pdp-top-sticky-bar .product-price[data-variant-id] span[data-actual-price], .custom-pdp-two-col-section .product-price[data-variant-id] span[data-actual-price]').forEach(el => {
            el.innerText = money_formatted;
          });
          document.querySelectorAll('.pdp-main-wrapper .product-price[data-variant-id] span[data-compare-price], .pdp-top-sticky-bar .product-price[data-variant-id] span[data-compare-price], .custom-pdp-two-col-section .product-price[data-variant-id] span[data-compare-price]').forEach(el => {
            el.style.removeProperty('display');
          });
          document.querySelectorAll('.pdp-main-wrapper .product-price[data-variant-id], .pdp-top-sticky-bar .product-price[data-variant-id], .custom-pdp-two-col-section .product-price[data-variant-id]').forEach(el => {
            const next = el.nextElementSibling;
            if (!next.classList.contains('promotional-price')) {
              el.insertAdjacentHTML('afterend', '<p class="promotional-price">Promotional price</p>');
            }
          });

          document.querySelectorAll(".closed_shop_price").forEach(el => {
            el.value = closed_shop.closed_shop_price;
            el.disabled = false;
          });
          document.querySelectorAll(".closed_shop_token").forEach(el => {
            el.value = closed_shop.closed_shop_token;
            el.disabled = false;
          });
      } else {
          document.querySelectorAll('.product-price[data-variant-id="'+variant_id+'"] span[data-compare-price]').forEach(el => {
            el.innerText = compare_at_price_formatted;
          });
          document.querySelectorAll('.product-price[data-variant-id="'+variant_id+'"] span[data-actual-price]').forEach(el => {
            el.innerText = money_formatted;
          });
          document.querySelectorAll('.product-price[data-variant-id="'+variant_id+'"] span[data-compare-price]').forEach(el => {
            el.style.removeProperty('display');
          });
          document.querySelectorAll('.product-price[data-variant-id="'+variant_id+'"]').forEach(el => {
            const next = el.nextElementSibling;
            if (!next || !next.classList.contains('promotional-price')) {
              el.insertAdjacentHTML('afterend', '<p class="promotional-price">Promotional price</p>');
            }
          });
      }
    } else {
      if (isPDP) {
        document.querySelectorAll('.pdp-main-wrapper .product-price[data-variant-id], .pdp-top-sticky-bar .product-price[data-variant-id], .custom-pdp-two-col-section .product-price[data-variant-id]').forEach(el => {
          const next = el.nextElementSibling;
          if (next.classList.contains('promotional-price')) {
              next.remove();
          }
        });

        document.querySelectorAll(".closed_shop_price").forEach(el => {
          el.value = "";
          el.disabled = true;
        });

        document.querySelectorAll(".closed_shop_token").forEach(el => {
          el.value = "";
          el.disabled = true;
        });
      } else {
        document.querySelectorAll('.product-price[data-variant-id="' + variant_id + '"]').forEach(el => {
          const next = el.nextElementSibling;
          if (next && next.classList.contains('promotional-price')) {
              next.remove();
          }
        });
      }
    }
  }
}
//ACF custom pricing JS END

/** Menu hover image start */
let lastBannerKey = null;

function getMenuBannerURL(newButtonURL) {
  if (!newButtonURL || newButtonURL.startsWith('http')) {
    return newButtonURL;
  }

  let finalURL = newButtonURL;

  if (window.Weglot && window.Shopify && Shopify.country) {
    const currentLanguage = Weglot.getCurrentLang().toLowerCase();
    const currentCountry = Shopify.country.toLowerCase();
    const localeHandle = `${currentLanguage}-${currentCountry}`;

    // Remove existing locale prefix if present (e.g. /en-de/)
    finalURL = finalURL.replace(/^\/[a-z]{2}-[a-z]{2}\//i, '/');

    // Add current locale prefix
    finalURL = `/${localeHandle}/${finalURL.startsWith('/') ? '' : '/'}${finalURL.replace(/^\//, '')}`;
  }
  return finalURL;
}

function getNewURL(newButtonURL) {
  if (!newButtonURL || newButtonURL.startsWith('http')) {
    return newButtonURL;
  }

  let finalURL = newButtonURL;

  if (window.Weglot && window.Shopify && Shopify.country) {
    const currentLanguage = Weglot.getCurrentLang().toLowerCase();
    const currentCountry = Shopify.country.toLowerCase();
    const localeHandle = `${currentLanguage}-${currentCountry}`;

    // Remove existing locale prefix if present (e.g. /en-de/)
    finalURL = finalURL.replace(/^\/[a-z]{2}(?=\/)/i, '');

    // Add current locale prefix
    finalURL = `/${localeHandle}/${finalURL.startsWith('/') ? '' : '/'}${finalURL.replace(/^\//, '')}`;
  }
  return finalURL;
}

function getTodayStore() {
  if (!window.storeNow || !window.storeOffset) {
    return null;
  }

  const offset = window.storeOffset;
  const sign = offset[0] === "-" ? -1 : 1;
  const hours = parseInt(offset.slice(1, 3), 10);
  const minutes = parseInt(offset.slice(3, 5), 10);

  const offsetMs = sign * ((hours * 60 + minutes) * 60000);

  const utc = window.storeNow * 1000;
  const storeTime = new Date(utc + offsetMs);

  return `${storeTime.getUTCFullYear()}-${String(storeTime.getUTCMonth() + 1).padStart(2, "0")}-${String(storeTime.getUTCDate()).padStart(2, "0")}`;
}

function getGlobalPromoBanner() {
  const el = document.getElementById("global-promo-banner-data");

  if (!el || el.dataset.enabled !== "true") {
    return null;
  }

  const activeRegion = window.SHOPIFY_CONTEXT?.region;
  const raw = (el.dataset.regions || "").toLowerCase().trim();
  const showInAll = raw === "*";

  const includedRegions = raw
    .split(",")
    .map(r => r.trim())
    .filter(Boolean);

  if (!showInAll) {
    if (!activeRegion || !includedRegions.includes(activeRegion)) {
      return null;
    }
  }

  const today = getTodayStore();

  if (!today) {
    return null;
  }

  const start = el.dataset.start;
  const end = el.dataset.end;

  if ((start && today < start) || (end && today > end)) {
    return null;
  }

  return {
    heading: el.dataset.heading,
    description: el.dataset.description,
    buttonLabel: el.dataset.buttonLabel,
    buttonURL: el.dataset.buttonUrl,
    image: el.dataset.image
  };
}

function applyBannerData(mainMenuId, data) {
  const key = JSON.stringify({ mainMenuId, ...data });

  if (lastBannerKey === key) return;
  lastBannerKey = key;

  const $button = $("#hover-button-" + mainMenuId);
  const $heading = $("#hover-heading-" + mainMenuId);
  const $description = $("#hover-description-" + mainMenuId);
  const $image = $("#hover-image-" + mainMenuId);

  $heading.text(data.heading || "");
  $description.text(data.description || "");

  if (data.buttonLabel && data.buttonURL) {
    const finalURL = getMenuBannerURL(data.buttonURL);
    $button
      .text(data.buttonLabel)
      .attr("href", finalURL)
      .css("visibility", "visible");
  } else {
    $button.css("visibility", "hidden");
  }

  if (data.image && $image.attr("src") !== data.image) {
    $image.attr("src", data.image);
  }
}

function setupMenuHoverEvents() {
    $(".mega-menu-links-col a").off("click");

    $(document).on(
        "mouseenter",
        ".main-nav-list a, .mega-menu-links-col a",
        function () {
            if (window.innerWidth <= 1023) return;

            const $this = $(this);
            const mainMenuId = $this.data("id");
            if (!mainMenuId) return;

            const banner = getGlobalPromoBanner();

            if (banner) {
                applyBannerData(mainMenuId, banner);
                return;
            }

            const isMainNav = $this.closest(".main-nav-list").length > 0;
            const isSubMenu = $this.closest(".mega-menu-links-col").length > 0;

            const $mainMenu = $(`.main-nav-list a[data-id="${mainMenuId}"]`);

            const mainData = {
                image: $mainMenu.data("image"),
                heading: $mainMenu.data("heading"),
                description: $mainMenu.data("description"),
                buttonLabel: $mainMenu.data("button-label"),
                buttonURL: $mainMenu.data("button-url"),
            };

            const hasMainBanner =
                mainData.image ||
                mainData.heading ||
                mainData.description ||
                mainData.buttonLabel ||
                mainData.buttonURL;

            if (hasMainBanner) {
                applyBannerData(mainMenuId, mainData);
                return;
            }

            if (isMainNav) {
                return;
            }

            if (isSubMenu) {
                const data = {
                    image: $this.data("image"),
                    heading: "",
                    description: "",
                    buttonLabel: "",
                    buttonURL: "",
                };

                if (!data.image) return;

                applyBannerData(mainMenuId, data);
            }
        }
    );
}

$(document).ready(setupMenuHoverEvents);
/*** Menu hover image end **/

$(document).ready(function () {
  $(".shopping-btn").on("click", function () {
    const cartDrawerCloseBtn = $(".cart-drawer__close-button");
    if (cartDrawerCloseBtn.length) {
      setTimeout(() => {
        cartDrawerCloseBtn.trigger("click");
      }, 300);
    }
  });

   // Close cart drawer when clicking outside it (on body)
    //$(document).on("click", function (e) {
    $(".cart-drawer .cart-overlay").on("click", function (e) {
      const $cartDrawer = $(".cart-drawer");
      const $closeBtn = $(".cart-drawer__close-button");
  
      $closeBtn.trigger("click");
    });

  // Prevent body click from closing drawer when clicking inside it
  $(".cart-drawer").on("click", function (e) {
    e.stopPropagation();
  });
});

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.quantity-select').forEach(function (selectEl) {
    selectEl.addEventListener('change', function (event) {
      const quantity = event.target.value;
      const dataId = selectEl.dataset.id;

      const quantityWrapper = selectEl.closest('.cart-item')?.querySelector('quantity-selector-component');

      if (!quantityWrapper) return;
      const inputEl = quantityWrapper.querySelector('.quantity_input'+dataId);
      if (!inputEl) return;
  
      inputEl.value = quantity;
      inputEl.dispatchEvent(new Event('blur', { bubbles: true }));
    });
  });
});

document.addEventListener('change', function(event) {
  if (event.target.matches('.quantity-select')) {
  
    const selectEl = event.target;
    const quantity = selectEl.value;
    const dataId = selectEl.dataset.id;

    const quantityWrapper = selectEl.closest('.cart-item')?.querySelector('quantity-selector-component');

    const inputEl = quantityWrapper.querySelector('.quantity_input' + dataId);
    if (!inputEl) return;

    inputEl.value = quantity;
    inputEl.dispatchEvent(new Event('blur', { bubbles: true }));
  }
});

$(document).ready(function () {
  const currentUrl = window.location.pathname;
  $(".inner-page-navbar ul li a").removeClass("active");
  $(".inner-page-navbar ul li a").each(function () {
    const linkHref = $(this).attr("href");
    // console.log(linkHref + ' '+ currentUrl);
    // Skip empty href or just "#"
    if (!linkHref || linkHref === "#") return;

    // Add active only if URL matches exactly or contains the path
    if (currentUrl.indexOf(linkHref) !== -1 && linkHref !== "/") {
      $(this).addClass("active");
    }
  });
});

/** Start Blog page menu filters **/
document.addEventListener('DOMContentLoaded', function () {
  const currentUrl = window.location.href;
  const tabLinks = document.querySelectorAll('.blog-listing-filter ul li a');

  tabLinks.forEach(function (link) {
    const linkHref = link.getAttribute('href');
    if (currentUrl.includes(linkHref) && linkHref.includes('/tagged/')) {
      document.querySelectorAll('.blog-listing-filter ul li').forEach(el => el.classList.remove('current'));
      link.closest('li').classList.add('current');
    }
  });
});
/** End Blog page menu filters **/


document.addEventListener("DOMContentLoaded", function () {
  const tocList = document.querySelector('.top-content .sidebar');
  const article = document.querySelector('.article-template');

  if (!tocList || !article) return;

  const headings = article.querySelectorAll('h2.scroll-section, h3.scroll-section');


  function generateId(text) {
    // Only take first part before comma (if any)
    let baseText = text.split(',')[0];
    return baseText
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '')        // Remove punctuation
      .replace(/\s+/g, '-')            // Replace spaces with hyphens
      .replace(/-+/g, '-');            // Remove repeated dashes
  }

  const usedIds = new Set();

  headings.forEach((heading, index) => {
    let id = generateId(heading.textContent);

    // Ensure unique ID if duplicate exists
    let uniqueId = id;
    let suffix = 1;
    while (usedIds.has(uniqueId)) {
      uniqueId = `${id}-${suffix++}`;
    }
    usedIds.add(uniqueId);

    heading.setAttribute('id', uniqueId);

    const li = document.createElement('li');
    li.setAttribute('data-target', `#${uniqueId}`);
    if (index === 0) li.classList.add('active-slide');

    const button = document.createElement('button');
    button.textContent = heading.textContent;

    li.appendChild(button);
    tocList.appendChild(li);
  });

  // Scroll and set active class
  document.querySelectorAll('.toc-list li button').forEach(btn => {
    btn.addEventListener('click', function () {
      const targetId = this.parentElement.getAttribute('data-target');
      const target = document.querySelector(targetId);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      // Update active-slide
      document.querySelectorAll('.toc-list li').forEach(li => li.classList.remove('active-slide'));
      this.parentElement.classList.add('active-slide');
    });
  });
});


/*** Collection List Start ****/
function applyFilters() {

  const selectedColors = [...document.querySelectorAll('.filter-color:checked')].map(el => el.value.toLowerCase());
  const selectedCategories = [...document.querySelectorAll('.filter-category:checked')].map(el => el.value.toLowerCase());
  const selectedFeatures = [...document.querySelectorAll('.filter-feature:checked')].map(el => el.value.toLowerCase());

  let visibleCount = 0;

  document.querySelectorAll('.product-list-card.collection_page').forEach(card => {
    const productTags = (card.dataset.tags || '')
      .split(',')
      .map(tag => tag.trim().toLowerCase());

    const productColor = (card.dataset.color || '')
      .split(',')
      .map(color => color.trim().toLowerCase());

    const title = card.dataset.title || 'No Title';

    const categoryTagMatch = selectedCategories.length === 0 ||
      selectedCategories.some(cat => productTags.includes(`category-${cat}`));

    const colorMatch = selectedColors.length === 0 ||
      selectedColors.some(color => productColor.includes(color));

    const featuresTagMatch = selectedFeatures.length === 0 ||
      selectedFeatures.some(feature => productTags.includes(`feature-${feature}`));


    const isVisible = categoryTagMatch && colorMatch && featuresTagMatch;

    if (isVisible) {
      card.style.display = 'block';
      visibleCount++;  
    } else {
      card.style.display = 'none';
    }
  });

  const countElement = document.getElementById('filter-result-count');
  if (countElement) {
    countElement.textContent = `${visibleCount} Product${visibleCount !== 1 ? 's' : ''}`;
  }
  applyACFPricing();
}
const applyFiltersButton = document.getElementById("apply-filters");
if (applyFiltersButton) {
  applyFiltersButton.addEventListener("click", applyFilters);
}



/*document.getElementById('custom-filters').addEventListener('submit', function (e) {
  console.log("submit");
  e.preventDefault();

  const form = e.target;
  const formData = new FormData(form);
  const params = new URLSearchParams();
console.log("params "+params);
  for (const [key, value] of formData.entries()) {
    params.append(key, value);
  }

  const collectionUrl = window.location.pathname;
  const filterUrl = `${collectionUrl}?${params.toString()}`;
  console.log(filterUrl);
  filterCollectionList(filterUrl);
  
});*/

document.querySelectorAll('input[type="radio"][name="sort_by"]').forEach((radio) => {
  radio.addEventListener('change', function () {
    const selectedValue = this.value;

    const collectionUrl = window.location.pathname;
    const filterUrl = `${collectionUrl}?sort_by=${selectedValue}`;

    filterCollectionList(filterUrl);
    applyACFPricing();
    //document.querySelector(".sort-by-filter").textContent = this.dataset.sortby;
  });
});

function contentanimationForAjax() {
  const observer = new IntersectionObserver(
    function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          $(entry.target).addClass("content-animate");
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.05,
    }
  );
  $(".content-visible").each(function () {
    observer.observe(this);
  });
}


function filterCollectionList(filterUrl){
  fetch(filterUrl)
    .then(res => res.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      const newProducts = doc.querySelector('#filtered-products');
      document.getElementById('filtered-products').innerHTML = newProducts.innerHTML;

      //applyFilters();
       const selectedColors = [...document.querySelectorAll('.filter-color:checked')].map(el => el.value.toLowerCase());
      const selectedCategories = [...document.querySelectorAll('.filter-category:checked')].map(el => el.value.toLowerCase());
      const selectedFeatures = [...document.querySelectorAll('.filter-feature:checked')].map(el => el.value.toLowerCase());
      
      const count = document.querySelectorAll('#filtered-products li').length;
      //document.querySelector('#filter-result-count').textContent = count+' Products';

      applyFilters();

      contentanimationForAjax();
      // Re-initialize
      document.querySelectorAll(".product-grid-list .product-list-card").forEach(function (card) {
        productDataUpdate(card, false);
      });
    });
}


function updateFilterCounts() {
  const checkboxes = document.querySelectorAll('.filter-checkbox-input');
  const counts = {};
  let anyChecked = false;

  checkboxes.forEach(cb => {
    if (cb.checked) {
      anyChecked = true;
      const type = cb.dataset.filtertype;
      counts[type] = (counts[type] || 0) + 1;
    }
  });

  const filterTypes = ['color', 'category', 'feature'];
  filterTypes.forEach(type => {
    // Support both desktop and mobile badges
    const badgeTypes = document.querySelectorAll(`.${type}-filter-badge`);
    badgeTypes.forEach(badgeType => {
      badgeType.style.display = counts[type] ? 'inline-flex' : 'none';
    });

    const badges = document.querySelectorAll(`#${type}-filter-badge-count`);
    badges.forEach(badge => {
      badge.textContent = counts[type] || 0;
    });
  });

  const sortTab = document.querySelector('.sort-by-tab');
  if (sortTab) {
    sortTab.classList.toggle("disabled", anyChecked);
  }
}
document.addEventListener('change', function (event) {
  if (event.target.classList.contains('filter-checkbox-input')) {
    updateFilterCounts();
  }
});

document.getElementById("clear-filter")?.addEventListener("click", () => {
	const collectionUrl = window.location.pathname;
    const filterUrl = `${collectionUrl}`;

    filterCollectionList(filterUrl);
    document.querySelector(".sort-by-filter").textContent = '';
});

document.getElementById("clear-all-filters")?.addEventListener("click", () => {
  // Uncheck all checkboxes in all filter groups
  document.querySelectorAll('.filter-color, .filter-category, .filter-feature')
    .forEach(input => input.checked = false);
  document.querySelectorAll('.filter-badge').forEach(badge => {
    badge.style.display = 'none';
  });
  document.querySelectorAll('.filter-badge-count').forEach(el => {
    el.textContent = '';
  });

  // Re-apply filter logic
  applyFilters();
});

document.querySelectorAll('.close-icon-btn').forEach(button => {
  button.addEventListener('click', () => {
    const filterType = button.dataset.filterType;

    // Uncheck all checkboxes of that filter group
    document.querySelectorAll(`.filter-${filterType}`).forEach(input => {
      input.checked = false;
    });

    // Hide the badge and clear count
    const badge = button.closest('.filter-badge');
    if (badge) {
      badge.style.display = 'none';
      const countSpan = badge.querySelector('span');
      if (countSpan) countSpan.textContent = '';
    }

    // Re-apply filtering
    applyFilters();
  });
});

/*** Collection List End ****/

/** sennheiser-consumer-ambassador-program iframe src start **/
$('.showIframeBtn').on('click', function () {
    $('.consumer-ambassador-iframe').toggleClass('active');
    $('body').toggleClass('consumer-ambassador-iframe-open');
});
/** sennheiser-consumer-ambassador-program iframe src end **/

// Show more button JS for collection page
document.addEventListener('click', function(e) {
  if (e.target.matches('.custom-collection-product-grid button.more-product[data-product-count-limit]')) {
    const hiddenItems = document.querySelectorAll('.custom-collection-product-grid .product-grid-list .product-list-card.hidden');
    hiddenItems.forEach(item => {
      item.classList.remove('hidden');
    });
    e.target.style.display = 'none';
    eqHeight();
  }
});
//End

function closeSortingDetailsMobile() {
  const detailsElements = document.querySelectorAll('.no-filter-yes-sorting .sorting-filter details[open]');
  detailsElements.forEach(el => el.removeAttribute('open'));
}

window.addEventListener('DOMContentLoaded', closeSortingDetailsMobile);
window.addEventListener('resize', closeSortingDetailsMobile);




/**Show cookie sidebar by cooking setting btn click start **/
document.getElementById('cookie-settings').addEventListener('click', function (e) {
  e.preventDefault();
  if (window.OneTrust) {
    OneTrust.ToggleInfoDisplay();
  } else {
    console.warn('OneTrust not found.');
  }
});
/**Show cookie sidebar by cooking setting btn click end **/


// Default language settings start--- 
/*window.onload = function () {
  const expiry = sessionStorage.getItem("weglot_selected_language" + "_expiry");
    if (expiry && Date.now() > parseInt(expiry, 10)) {
      sessionStorage.removeItem("weglot_selected_language");
      sessionStorage.removeItem("weglot_selected_language" + "_expiry");
    }
    const storedLang = sessionStorage.getItem("weglot_selected_language");
    if (window.location.href.toLowerCase().includes("ch.sennheiser-hearing.com/en".toLowerCase())) {
      var defaultLang = 'en';
    }else if (window.location.href.toLowerCase().includes("ch.sennheiser-hearing.com/fr".toLowerCase())) {
      var defaultLang = 'fr';
    }else{
      var defaultLang = 'de';
    }
        if (storedLang && storedLang == 'en') {
        defaultLang = 'en';
      }
      Weglot.switchTo(defaultLang);



 }*/
//  window.addEventListener("pageshow", function (event) {
//     const selectCountry = document.getElementById("country-select");
//     selectCountry.value = "CH";
// });
// document.addEventListener("DOMContentLoaded", function () {
//   // window.currentMarket = null;
//   // console.log(window.currentMarket);
//   countrySelect.value = window.currentMarket.toUpperCase();
//   const selectedCountry = countrySelect.options[countrySelect.selectedIndex].text; 
//   const languages = countryLanguageMap[selectedCountry] || [];

//   languageSelect.innerHTML = '<option value="">Select a language</option>';

//   // Populate new options
//   languages.forEach(language => {
//     const option = document.createElement('option');
//     option.value = language.value;
//     option.textContent = language.label;
//     languageSelect.appendChild(option);
//   });



//     const select = document.getElementById("language-select");
//     if (!select) return;

//    setTimeout(function() {
//     select.value = Weglot.getCurrentLang();
//     }, 500)
//   });
// Default language settings end---


  //Show More on Similar Products
  function showMoreProducts() {
    document.getElementById('more-products').style.display = 'flex';
    document.getElementById('show-more-button').style.display = 'none';
  }

/* canvas images */
function productrotation() {
  const canvases = document.querySelectorAll(".product360Canvas");
 
  canvases.forEach((canvas) => {
    if (!canvas) return;
 
    const ctx = canvas.getContext("2d");
 
    const productNumber = canvas.dataset.product || "1";
    const frameCount = parseInt(canvas.dataset.framecount, 10) || 1;
 
    const images = [];
    let currentFrame = 0;
    let isDragging = false;
    let startX = 0;
   
    for (let i = 0; i < frameCount; i++) {
      const img = new Image();
      const fileimage = '//eu.sennheiser-hearing.com/cdn/shop/files/0_267.webp?v=17208';
      const fileimage2 =  "//eu.sennheiser-hearing.com/cdn/shop/files/";
      img.src = `${fileimage2}0_${i + 1}.webp`;
      //img.src = `canvas-images/product${productNumber}/0_${i + 1}.webp`;
      images.push(img);
    }
 
    images[0].onload = function () {
      ctx.drawImage(images[0], 0, 0, canvas.width, canvas.height);
    };
 
    function drawFrame(frameIndex) {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(images[frameIndex], 0, 0, canvas.width, canvas.height);
    }
 
    canvas.addEventListener("mousedown", (e) => {
      isDragging = true;
      startX = e.pageX;
    });
 
    canvas.addEventListener("mouseup", () => {
      isDragging = false;
    });
 
    canvas.addEventListener("mousemove", (e) => {
      if (!isDragging) return;
 
      let delta = e.pageX - startX;
      const sensitivity = 1;
 
      if (Math.abs(delta) > 1) {
        const framesToMove = Math.floor(Math.abs(delta) * sensitivity);
 
        currentFrame =
          delta > 0
            ? (currentFrame - framesToMove + frameCount) % frameCount
            : (currentFrame + framesToMove) % frameCount;
 
        drawFrame(currentFrame);
        startX = e.pageX;
      }
    });
  });
}
window.addEventListener("DOMContentLoaded", productrotation);

// 16-01-26 : Searchanise custom JS Start
document.addEventListener('Searchanise.Loaded', function() {
  (function($) {
    const priceSource = Searchanise.GetWidgets().options.PriceSource;
    const pricelist = getCookie("pricelist");

    // NOTE: Searchanise app team will provide this encoded values for each price shop
    // Don't change the variables name and value
    const priceMap = {
      'cs_euro': "variant_metafield_8c76cd9e7bfb314194b6cd7d3d0be07e",
      'corporatebenefits': "variant_metafield_70bee1fe628389d83f9da33345ea17ad",
      'sennheiserde': "variant_metafield_0190ce5917d092fe4abb8c6aaddbb200",
      'sonovade': "variant_metafield_a8c8eea7a7e5ca978119ce4b52aeb2b4",
      'ticketsprinter': "variant_metafield_ae41b8b5adcab3edc5fe657134231769",
      'unidays': "variant_metafield_b47a57162e4e64fcdb9188adfdb738ef"
    };

    // MODULE 1: UI Helpers
    function applyRefurbishedTag($product, productData) {
      if (!productData.title || !productData.title.toLowerCase().includes('refurbished')) return;

      const $thumbnail = $product.find('.snize-thumbnail');
      const $img = $thumbnail.find('img.snize-item-image');

      if ($thumbnail.find('.product-tag').length === 0 && $img.length) {
        $('<div class="product-tag">Refurbished</div>').insertBefore($img);
      }
    }

    function reorderProductContent($product) {
      const $overHidden = $product.find('.snize-overhidden');
      const $optionsBox = $overHidden.find('.snize-options-box');

      if ($overHidden.length && $optionsBox.length && $overHidden.find('.custom-content-wrapper').length === 0) {
        $optionsBox.detach();
        $overHidden.wrapInner('<div class="custom-content-wrapper"></div>');
        $overHidden.prepend($optionsBox);
      }
    }

    function updateButtonAndPricingUI($product, productData) {
      const $btn = $product.find('.snize-action-button');
      const isComingSoon = productData.metafield_51f77e6c35e2eb54d7d099b045565bbc === 'true';
      const isPreorder = productData.metafield_2b0a84e7d0f19a111646b7a5683c8d2d === "true";

      if (isComingSoon) {
        $product.find('.snize-price, .snize-price-list, .snize-discounted-price, .snize-old-price, .promotional-price').hide();

        if ($btn.length) {
          $btn.prop('disabled', true)
              .addClass('coming-soon-disabled')
              .text('Coming Soon')
              .off('click');
        }
        return { isComingSoon: true };
      } 
      
      if (isPreorder && $btn.length) {
        $btn.text('Preorder');
      }

      if (pricelist && productData[priceMap[pricelist]]) {
        const $priceList = $product.find('.snize-price-list');
        if ($priceList.length && !$priceList.next('.promotional-price').length) {
          $priceList.after('<p class="promotional-price">Promotional price</p>');
        }
      }

      return { isComingSoon: false };
    }

    // MODULE 2: Cart Logic
    function bindAddToCartAction($product, productData) {
      const $addToCartBtn = $product.find('.snize-add-to-cart-button');
      if (!$addToCartBtn.length) return;

      $addToCartBtn.off('click').on('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        
        const $target = $(event.target);
        
        if ($target.hasClass('size-button-view-cart')) {
          location.href = '/cart';
          return;
        }

        let properties = {};
        let closed_shop_price = productData[priceMap[pricelist]];

        if (closed_shop_price) {
          closed_shop_price = String(closed_shop_price).includes(',') 
            ? String(closed_shop_price).replace(/,/g, '') 
            : String(closed_shop_price) + '00';

          let closed_shop_token = 0;
          const processToken = (char) => {
            closed_shop_token = (closed_shop_token + Number(char)) * 31 % 16777216;
          };

          String(productData.add_to_cart_id).split('').forEach(processToken);
          closed_shop_price.split('').forEach(processToken);

          properties = {
            _external_price: String(closed_shop_price).replace(/,/g, '.'),
            _external_token: String(closed_shop_token),
            _external_pricelist: pricelist
          };
        }

        const cartItemComponentsSectionIds = Array.from(document.querySelectorAll('cart-items-component'))
          .filter(item => item.dataset && item.dataset.sectionId)
          .map(item => item.dataset.sectionId);

        $.ajax({
          method: 'post',
          url: '/cart/add.js',
          data: {
            id: productData.add_to_cart_id,
            quantity: 1,
            properties,
            sections: cartItemComponentsSectionIds.join(',')
          },
          dataType: 'json',
          beforeSend: function () {
            $target.prop('disabled', true).data('text', $target.text()).text('...');
          },
          success: function (data) {
            const searchOverlay = document.querySelector(".search-overlay");
            if (searchOverlay) {  
              searchOverlay.remove();
              $("body").removeClass("search-input-expand");
            }
            
            document.dispatchEvent(new Event('ajaxProduct:added', { 'bubbles': true }));

            fetch('/cart.js', { headers: { Accept: 'application/json' } })
              .then((res) => res.json())
              .then((cart) => {
                document.dispatchEvent(
                  new CartAddEvent({}, productData.add_to_cart_id.toString(), {
                    source: 'jquery-custom-add',
                    itemCount: cart.item_count,
                    productId: productData.add_to_cart_id,
                    sections: cart.sections || data.sections,
                  })
                );
              })
              .catch((err) => console.error('Failed to refresh cart count:', err));
            
            $target.prop('disabled', false)
                  .addClass('size-button-view-cart')
                  .text(`${Searchanise.GetWidgets().options.LabelResultsViewCart}`);
          },
          error: function () {
            $target
              .prop('disabled', false)
              .text($target.data('text'));
          }
        });
      });
    }

    // CORE CONTROLLER: Loop once, execute cleanly
    function processSearchaniseProducts(container, config = {}) {
      $('.snize-product', container).each(function () {
        const $product = $(this);
        const productData = $product.data('snize_item_data');

        if (!productData) return;

        applyRefurbishedTag($product, productData);
        
        if (config.reorderContent) {
          reorderProductContent($product);
        }

        const { isComingSoon } = updateButtonAndPricingUI($product, productData);

        if (!isComingSoon && pricelist) {
          bindAddToCartAction($product, productData);
        }
      });
    }

    // EVENT LISTENERS
    $(document).on('Searchanise.DataRequestEnd', function(event, type, params, data) {
      if (pricelist && data?.items?.length) {
        for (let item of data.items) {
          const pricelistKey = priceMap[pricelist];

          if (item[pricelistKey]) {
            if (priceSource === 'first_variant' && item?.shopify_variants?.length && item.shopify_variants[0]?.search_variant_metafields_data[pricelistKey]) {
              item.shopify_variants[0].price = item.shopify_variants[0].search_variant_metafields_data[pricelistKey].replace(/,/g, '.');
            }
            item.price = item[pricelistKey].replace(/,/g, '.');
          }
        }
      }
    });

    $(document).on('Searchanise.AutocompleteUpdated', function(event, input, container) {
      processSearchaniseProducts(container, { reorderContent: false });
    });

    $(document).on('Searchanise.ResultsUpdated', function (event, container) {
      processSearchaniseProducts(container, { reorderContent: true });
      eqHeight();
    });

  })(window.Searchanise.$);
});
// 16-01-26 : Searchanise custom JS End

//for specific slider redirects
document.addEventListener("DOMContentLoaded", function() {

  if (typeof Weglot !== "undefined") {

    var currentLang = Weglot.getCurrentLang(); 
    var currentCountry = Shopify.country.toLowerCase();
    var localeHandle = currentLang + "-" + currentCountry;

    var externalLocales = ["en-at","de-at","en-be","fr-be","fr-fr","en-de","de-de","fr-lu","de-lu","en-nl","en-fi","en-ie","es-es","da-dk"];

    var staticUrl = "https://www.sennheiser.com/en-de/product-families/hd-490-pro-mixing-headphones";

    var banners = document.querySelectorAll('[data-dynamic-redirect="true"]');

    banners.forEach(function(link) {

      if (externalLocales.includes(localeHandle)) {
        link.href = "https://www.sennheiser.com/" 
                    + localeHandle 
                    + "/product-families/hd-490-pro-mixing-headphones";
      } else {
        link.href = staticUrl;
      }

    });

  }

});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.add-to-cart-text').forEach(wrapper => {
    
    const contentEl = wrapper.querySelector('[data-buyButtonText]');
    
    if (contentEl) {
      wrapper.dataset.translatedAddToCart = contentEl.textContent.trim();
    }

  });
});

document.addEventListener("DOMContentLoaded", function () {

  const supportLink = document.getElementById("external-support-link");
  const mobilesupportLink = document.getElementById("mobile-external-support-link");
  
  if (!supportLink) return;

  // Detect Shopify locale
  let locale = document.documentElement.lang.toLowerCase();
  var currentCountry = Shopify.country.toLowerCase();
  if(locale != '' && currentCountry != ''){
    var newurl = "https://support.sennheiser-hearing.com/hc/"+locale+"-"+currentCountry;
  }else{
    var newurl = "https://support.sennheiser-hearing.com/";
  }
  supportLink.href = newurl;
  mobilesupportLink.href= newurl;
});
// document.addEventListener("DOMContentLoaded", function () {

//   function updateCTAButton() {

//     const ctaButton = document.querySelector('#counter-notify-btn');
//     if (!ctaButton) return;

//     // Get Weglot language safely
//     let currentLang = "en";

//     if (typeof Weglot !== "undefined") {
//       currentLang = Weglot.getCurrentLang().toLowerCase();
//     }

//     console.log("Current Lang:", currentLang);

//     // Language → HubSpot CTA mapping
//     const langClassMap = {
//       'en': 'hs-cta-trigger-button-395281377490',     // Replace xx with your EN CTA ID
//       'de': 'hs-cta-trigger-button-395411473650',     // Replace xx with your DE CTA ID
//       'fr': 'hs-cta-trigger-button-404548245700',     // Replace xx with your FR CTA ID
//       'nl': 'hs-cta-trigger-button-404548518134',     // Replace xx with your NL CTA ID
//       'hu': 'hs-cta-trigger-button-404548519141',     // Replace xx with your HU CTA ID
//       'it': 'hs-cta-trigger-button-404548519153',     // Replace xx with your IT CTA ID
//       'pt': 'hs-cta-trigger-button-404550840547',     // Replace xx with your PT CTA ID
//       'es': 'hs-cta-trigger-button-404550841538',     // Replace xx with your ES CTA ID
//       'zh': 'hs-cta-trigger-button-404549540056',     // Replace xx with your ZH CTA ID
//       'zh-hk': 'hs-cta-trigger-button-404549540089',  // Replace xx with your ZH-HK CTA ID
//       'ja': 'hs-cta-trigger-button-404549541059',     // Replace xx with your JA CTA ID
//       'zh-tw': 'hs-cta-trigger-button-404549541077',  // Replace xx with your ZH-TW CTA ID
//       'th': 'hs-cta-trigger-button-404549541084',     // Replace xx with your TH CTA ID
//       'ar': 'hs-cta-trigger-button-404549542078',     // Replace xx with your AR CTA ID
//       'vi': 'hs-cta-trigger-button-404549544158'      // Replace xx with your VI CTA ID
//     };

//     /* ------------------------------
//        REMOVE OLD HUBSPOT CTA CLASSES
//     --------------------------------*/
//     ctaButton.classList.forEach(cls => {
//       if (cls.startsWith("hs-cta-trigger-button-")) {
//         ctaButton.classList.remove(cls);
//       }
//     });

//     // Always keep base class
//     ctaButton.classList.add("hs-cta-trigger-button");

//     // Add correct language CTA class
//     if (langClassMap[currentLang]) {
//       ctaButton.classList.add(langClassMap[currentLang]);
//     }

//     console.log("Updated Classes:", ctaButton.className);
//   }

//   // Run once
//   updateCTAButton();

//   /* ------------------------------
//      FIX FOR WEGLOT LANGUAGE SWITCH
//   --------------------------------*/
//   if (typeof Weglot !== "undefined") {
//     Weglot.on("languageChanged", function () {
//       updateCTAButton();
//     });
//   }

// });

/*M5 launch - sign up form class js starts */
document.addEventListener("DOMContentLoaded", function () {
  const ctaButton = document.querySelector('.custom-countdown-slide-btn');

  if (!ctaButton) return;

  // Get current Weglot language
  const currentLang =
    typeof Weglot !== "undefined"
      ? Weglot.getCurrentLang().toLowerCase()
      : "en";

  // Dynamic language class mapping
  const langClassMap = {
      'en': 'hs-cta-trigger-button-395281377490',      
      'de': 'hs-cta-trigger-button-395411473650',      
      'fr': 'hs-cta-trigger-button-404548245700',      
      'nl': 'hs-cta-trigger-button-404548518134',      
      'hu': 'hs-cta-trigger-button-404548519141',     
      'it': 'hs-cta-trigger-button-404548519153',     
      'pt': 'hs-cta-trigger-button-404550840547',      
      'es': 'hs-cta-trigger-button-404550841538',      
      'zh': 'hs-cta-trigger-button-404549540056',      
      'zh-hk': 'hs-cta-trigger-button-404549540089',  
      'ja': 'hs-cta-trigger-button-404549541059',      
      'zh-tw': 'hs-cta-trigger-button-404549541077', 
      'th': 'hs-cta-trigger-button-404549541084',      
      'ar': 'hs-cta-trigger-button-404549542078',     
      'vi': 'hs-cta-trigger-button-404549544158'    
    };
    

  // Add common class
  ctaButton.classList.add("hs-cta-trigger-button");


  // Remove all previous lang classes
  Object.values(langClassMap).forEach((className) => {
    ctaButton.classList.remove(className);
  });

  // Add dynamic lang class
  if (langClassMap[currentLang]) {
    ctaButton.classList.add(langClassMap[currentLang]);
  }
});

/* 19-05-26 : M5 Exp Page Signup Form Start */
document.addEventListener("DOMContentLoaded", () => {
  const ctaButtons = document.querySelectorAll(".m5-hubspot-form-cta");

  if (!ctaButtons.length) return;

  const langClassMap = {
    en: "hs-cta-trigger-button-395281377490",
    de: "hs-cta-trigger-button-395411473650",
    fr: "hs-cta-trigger-button-404548245700",
    nl: "hs-cta-trigger-button-404548518134",
    hu: "hs-cta-trigger-button-404548519141",
    it: "hs-cta-trigger-button-404549519153",
    pt: "hs-cta-trigger-button-404550840547",
    es: "hs-cta-trigger-button-404550841538",
    zh: "hs-cta-trigger-button-404549540056",
    "zh-hk": "hs-cta-trigger-button-404549540089",
    ja: "hs-cta-trigger-button-404549541059",
    "zh-tw": "hs-cta-trigger-button-404549541077",
    th: "hs-cta-trigger-button-404549541084",
    ar: "hs-cta-trigger-button-404549542078",
    vi: "hs-cta-trigger-button-404549544158"
  };

  const CTA_CLASS_PREFIX = "hs-cta-trigger-button-";

  function getCurrentLanguage() {
    if (
      typeof Weglot !== "undefined" &&
      typeof Weglot.getCurrentLang === "function"
    ) {
      return (Weglot.getCurrentLang() || "en").toLowerCase();
    }

    return "en";
  }

  function updateCTAButton() {
    const currentLang = getCurrentLanguage();
    const langClass = langClassMap[currentLang];

    ctaButtons.forEach((button) => {
      button.className = button.className
        .split(" ")
        .filter((cls) => !cls.startsWith(CTA_CLASS_PREFIX))
        .join(" ");

      button.classList.add("hs-cta-trigger-button");

      if (langClass) {
        button.classList.add(langClass);
      }
    });
  }

  updateCTAButton();

  if (typeof Weglot !== "undefined" && typeof Weglot.on === "function") {
    Weglot.on("languageChanged", updateCTAButton);
  }
});
/* 19-05-26 : M5 Exp Page Signup Form End */

document.addEventListener('DOMContentLoaded', function () {
    const videoWrapper = document.getElementById('m5-language-video');

    if (!videoWrapper) return;

    const locale = window.location.pathname.split('/')[1]?.toLowerCase() || '';

    let videoUrl = 'https://cdn.shopify.com/videos/c/o/v/d776938ff42841cca03aed8e8787d0e0.mp4'; // Default English

    switch (locale) {
        case 'de-de':
            videoUrl = 'https://cdn.shopify.com/videos/c/o/v/e673c76b3608488f9a10b6faad16766a.mp4';
            break;
        case 'fr-fr':
          videoUrl = 'https://cdn.shopify.com/videos/c/o/v/b0f234e4df9d4b8485b3ebf36b8f4a92.mp4';
            break;
        case 'nl-be':
        case 'nl-nl':
          videoUrl = 'https://cdn.shopify.com/videos/c/o/v/5ed5053116e149e29a03957f426de0c7.mp4';
            break;
        case 'it-it':
          videoUrl = 'https://cdn.shopify.com/videos/c/o/v/9fac106e110a477ba2d85f71c6ba20fb.mp4';
            break;
        case 'pt-pt':
          videoUrl = 'https://cdn.shopify.com/videos/c/o/v/f71714fc5af744a2ad6f1d3482f0dfc3.mp4';
            break;
        case 'es-es':
            videoUrl = 'https://cdn.shopify.com/videos/c/o/v/55e8f3142a804440ae2c5694aa3afe65.mp4';
            break;
    }

    const video = videoWrapper.querySelector('video');
    const source = video.querySelector('source');

    source.src = videoUrl;

    video.load();

    video.muted = true;
    video.autoplay = true;
    video.playsInline = true;

    // video.play().catch(function(error) {
    //     console.log('Autoplay prevented:', error);
    // });
});

/* 09-06-26 : Userway Accessibility Start */
(function (d) {
  let retries = 0;
  const maxRetries = 20;

  const loadUserWay = () => {
      let language = 'en';

      try {
          if (window.Weglot && typeof Weglot.getCurrentLang === 'function') {
              language = Weglot.getCurrentLang();
          }
      } catch (e) {
          console.error('Unable to determine Weglot language', e);
      }

      if (document.querySelector('script[src*="cdn.userway.org/widget.js"]')) {
          return;
      }

      const s = d.createElement('script');

      s.setAttribute('data-language', language);
      s.setAttribute('data-position', '3');
      s.setAttribute('data-color', '#037cc2');
      s.setAttribute('data-mobile', 'true');
      s.setAttribute('data-account', 'RhhHNcREkt');

      s.setAttribute('src', 'https://cdn.userway.org/widget.js');
      (d.head || d.body).appendChild(s);
  };

  const initUserWay = () => {
      if (window.Weglot && typeof Weglot.getCurrentLang === 'function') {
          loadUserWay();
      } else if (retries < maxRetries) {
        retries++;
        setTimeout(initUserWay, 100);
    }
  };

  initUserWay();
})(document);
/* 09-06-26 : Userway Accessibility End */

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('a.custom-btn-link').forEach(function (anchor) {
        const href = anchor.getAttribute('href');

        if (!href) return;

        anchor.href = getNewURL(href);
    });
});

window.addEventListener('load', function () {
    document.querySelectorAll('iframe[src*="euwiderrufsbutton.de"]').forEach(function (iframe) {

        const pageLang = document.documentElement.lang.toLowerCase(); // de, fr, en

        const url = new URL(iframe.src);

        if (url.searchParams.get('c_locale') !== pageLang) {
            url.searchParams.set('c_locale', pageLang);
            iframe.src = url.toString();
        }
    });
});

document.addEventListener('DOMContentLoaded', function () {
    const video = document.getElementById('mtw5-slide-desk');
    const mobVideo = document.getElementById('mtw5-slide-mob');
    const source = document.getElementById('mtw5-slide-desk-video-source');
    const mobSource = document.getElementById('mtw5-slide-mob-video-source');

    if (!video || !source) return;

    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Detect Apple devices
    const isIOS =
        /iPad|iPhone|iPod/.test(userAgent) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

    const isMacOS = /Macintosh/.test(userAgent);

    // Apple devices → HEVC MP4
    if (isIOS || isMacOS) {
        source.src = source.dataset.hevc;
        source.src = 'https://cdn.shopify.com/videos/c/o/v/16ac47700db142c19e8a9ad7720dbc06.mp4';
        source.type = 'video/mp4';
        mobSource.src = mobSource.dataset.hevc;
        mobSource.src = 'https://cdn.shopify.com/videos/c/o/v/08f92aafccca4a6db2d0b2b2af6dd569.mp4';
        mobSource.type = 'video/mp4';
    }
    // Windows / Android / other devices → WebM
    else {
        source.src = source.dataset.webm;
        source.src = 'https://cdn.shopify.com/videos/c/o/v/7e2fcc310986484ea2f32a29e4bb3906.webm';
        source.type = 'video/webm';
        mobSource.src = mobSource.dataset.hevc;
        mobSource.src = 'https://cdn.shopify.com/videos/c/o/v/c59975a4485d4a15acc559264a40b859.webm';
        mobSource.type = 'video/webm';
    }

    video.load();
    mobVideo.load();
});


document.addEventListener('DOMContentLoaded', function () {
    const image = document.getElementById('paris-video-show-image');

    if (!image) return;

    const locale = window.location.pathname.split('/')[1]?.toLowerCase() || '';

    // Default English image from Shopify
    let imageUrl = image.dataset.defaultSrc;

    switch (locale) {
        case 'fr-fr':
            imageUrl = 'https://cdn.shopify.com/s/files/1/0553/9636/8578/files/MOMENTUM_5_ATF_Image_10_FR_1_Les_numeriques_what_hifi_1341d782-755d-4440-a0c9-3d4e4168b365.png';
            break;

        // Add other languages here if required
    }

    image.src = imageUrl;
});

/* 23-10-26 : Syncs OneTrust(C0004) consent with Bazaarvoice Start */
(() => {
  const OT_CATEGORY = 'C0004';
  const BV_COOKIES = ['BVBRANDID', 'BVBRANDSID'];
  let timeoutId = null;

  const setBVConsent = (granted, retries = 150) => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    const cookieConsent = window.BV?.cookieConsent;

    if (cookieConsent?.setConsent) {
      cookieConsent.setConsent(
        Object.fromEntries(BV_COOKIES.map((name) => [name, granted]))
      );
    } else if (retries > 0) {
      timeoutId = setTimeout(() => setBVConsent(granted, retries - 1), 100);
    }
  };

  const handleGroups = (groups) => {
    const activeGroups = Array.isArray(groups) ? groups : String(groups).split(',');
    setBVConsent(activeGroups.includes(OT_CATEGORY));
  };

  window.addEventListener('OneTrustGroupsUpdated', (event) => handleGroups(event.detail));

  if (window.OnetrustActiveGroups) handleGroups(window.OnetrustActiveGroups);
})();
/* 23-10-26 : Syncs OneTrust(C0004) consent with Bazaarvoice End */